import { render } from "./Main.vue?vue&type=template&id=06e7c153"
const script = {}
script.render = render

export default script